export function getView(width) {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 1023) {
    newView = 'TabViewLg';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
}
const actions = {
  COLLPSE_CHANGE: 'COLLPSE_CHANGE',
  COLLPSE_OPEN_DRAWER: 'COLLPSE_OPEN_DRAWER',
  CLOSE_DRAWER: 'CLOSE_DRAWER',
  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
  TOGGLE_ALL: 'TOGGLE_ALL',
  CHANGE_CURRENT: 'CHANGE_CURRENT',
  CLEAR_MENU: 'CLEAR_MENU',
  APP_ITEM_CHANGED: 'APP_ITEM_CHANGED',

  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  APPLY_CURRENT_PAGE: 'APPLY_CURRENT_PAGE',
  SET_CURRENT_ACTION: 'SET_CURRENT_ACTION',
  CLEAR_CURRENT_ACTION: 'CLEAR_CURRENT_ACTION',

  TOGGLE_DRAWER: 'TOGGLE_DRAWER',

  ADD_SYSTEM_LOGS: 'ADD_SYSTEM_LOGS',
  ADDING_SYSTEM_LOGS: 'ADDING_SYSTEM_LOGS',
  ADD_SYSTEM_LOGS_SUCCESS: 'ADD_SYSTEM_LOGS_SUCCESS',
  ADD_SYSTEM_LOGS_FAILED: 'ADD_SYSTEM_LOGS_FAILED',

  TOGGLE_COLLAPSED_MODULES: 'TOGGLE_COLLAPSED_MODULES',
  TOGGLE_COLLAPSED_PAGE: 'TOGGLE_COLLAPSED_PAGE',

  SET_NOTIFICATION_REMINDER: 'SET_NOTIFICATION_REMINDER',

  GENERATE_REPORT_STATUS: 'GENERATE_REPORT_STATUS',
  RESET_GENERATE_REPORT: 'RESET_GENERATE_REPORT',
  REMOVE_GENERATE_REPORT_STATUS: 'REMOVE_GENERATE_REPORT_STATUS',

  GENERATE_SRF_TRANSACTION_REPORT_STATUS: 'GENERATE_SRF_TRANSACTION_REPORT_STATUS',
  RESET_GENERATE_SRF_TRANSACTION_REPORT: 'RESET_GENERATE_SRF_TRANSACTION_REPORT',
  REMOVE_GENERATE_SRF_TRANSACTION_REPORT_STATUS: 'REMOVE_GENERATE_SRF_TRANSACTION_REPORT_STATUS',

  toggleCollapsed: () => ({
    type: actions.COLLPSE_CHANGE
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== 'DesktopView';
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height
    };
  },
  toggleOpenDrawer: () => ({
    type: actions.COLLPSE_OPEN_DRAWER
  }),
  closeDrawer: () => ({
    type: actions.CLOSE_DRAWER
  }),
  toggleCollapseModules: () => ({
    type: actions.TOGGLE_COLLAPSED_MODULES
  }),
  toggleCollapsedPage: (collapsed = null) => ({
    type: actions.TOGGLE_COLLAPSED_PAGE,
    collapsed
  }),
  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys
  }),
  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current
  }),
  clearMenu: () => ({ type: actions.CLEAR_MENU }),
  appItemChange: item => ({
    type: actions.APP_ITEM_CHANGED,
    item
  }),
  setCurrentPage: payload => ({
    type: actions.SET_CURRENT_PAGE,
    payload
  }),
  setCurrentAction: payload => ({
    type: actions.SET_CURRENT_ACTION,
    payload
  }),
  clearCurrentAction: () => ({
    type: actions.CLEAR_CURRENT_ACTION
  }),
  toggleDrawer: () => ({
    type: actions.TOGGLE_DRAWER
  }),
  addSystemLogs: payload => ({
    type: actions.ADD_SYSTEM_LOGS,
    payload
  }),
  setReminderTrigger: payload => ({
    type: actions.SET_NOTIFICATION_REMINDER,
    payload
  }),
  generateReport: payload => ({
    type: actions.GENERATE_REPORT_STATUS,
    payload
  }),
  resetGenerateReport: () => ({
    type: actions.RESET_GENERATE_REPORT
  }),
  removeGenerateReportStatus: key => ({
    type: actions.REMOVE_GENERATE_REPORT_STATUS,
    key
  }),
  generateSRFTransactionReport: payload => ({
    type: actions.GENERATE_SRF_TRANSACTION_REPORT_STATUS,
    payload
  })
};
export default actions;
